import { RootState } from "../../redux-store";

export const selectNotifications = (state: RootState) =>
  state.notifications.notifications;

export const selectShowNetworkErrorMessage = (state: RootState) =>
  state.notifications.networkError;
